import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import {
  ChangeTitle,
  decrypt,
  encrypt,
  selectFormStyle,
  selectFormStyle2,
  toAbsoluteUrl,
} from "../../helpers/Reusable";
import { Link, useLocation } from "react-router-dom";
import PresentationList from "../presentations/PresentationList";
import VideoList from "../videos/VideoList";
import ArticleList from "./ArticleList";
import QueriesList from "../queries/QueriesList";
import {
  deleteCookie,
  getCookie,
  setCookie,
} from "../../helpers/CookieComponent";
import Select from "react-select";
import { apiHeader, postData } from "../../helpers/ApiHelper";

const ArticleFormat = () => {
  ChangeTitle("Articles");
  const articleCategoryId = getCookie("articleCategoryId");
  // const articleCategoryName =
  //   decrypt(getCookie("articleCategoryName")) || "Article";
  const menu = getCookie("menu");
  const [mainMenu, setMainMenu] = useState(menu || "Article");
  const [articleCategoryName, setArticleCategoryName] = useState("Article");
  const [articleType, setArticleType] = useState("text");
  const [articleCategory, setArticleCategory] = useState("");
  const [articleDate, setArticleDate] = useState("");
  const [articleAuthor, setArticleAuthor] = useState("");
  const [articleDeliveredAt, setArticleDeliveredAt] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [authorList, setAuthorList] = useState([]);
  const [deliveredAtList, setDeliveredAtList] = useState([]);
  const [articleFilterData, setArticleFilterData] = useState({});

  // Article Category List API Call
  const viewCatogoryList = async () => {
    var response = await postData(
      "article/category/list",
      {},
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const categoryData = data.map((data) => {
        return {
          value: data._id,
          label: data.categoryName,
        };
      });
      setCategoryList(categoryData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };
  // Article Author List API Call
  const viewAuthorList = async (type) => {
    const param = {
      articleType: type,
    };

    var response = await postData(
      "article/author/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      const listData = data.map((data) => {
        return {
          value: data,
          label: data,
        };
      });
      setAuthorList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };
  // Article Delevered At List API Call
  const viewDeleveredAtList = async (type) => {
    const param = {
      articleType: type,
    };

    var response = await postData(
      "article/deliveredat/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      const listData = data.map((data) => {
        return {
          value: data,
          label: data,
        };
      });
      setDeliveredAtList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewCatogoryList();
  }, []);

  useEffect(() => {
    if (articleType) {
      viewAuthorList(articleType);
      viewDeleveredAtList(articleType);
    }
  }, [articleType]);

  // Filter Data Get From Cookie
  useEffect(() => {
    const articleFilterData = JSON.parse(
      decrypt(getCookie("articleFilter")) || "{}"
    );

    if (articleFilterData) {
      setArticleCategory(articleFilterData.articleCategory || "");
      setArticleDate(articleFilterData.articleDate || "");
      setArticleAuthor(articleFilterData.articleAuthor || "");
      setArticleDeliveredAt(articleFilterData.articleDeliveredAt || "");
      setArticleCategoryName(
        categoryList.find(
          (data) => data.value == articleFilterData.articleCategory
        )
      );
    }
  }, [categoryList]);

  useEffect(() => {
    const articleFilterData = JSON.parse(
      decrypt(getCookie("articleFilter")) || "{}"
    );

    if (articleFilterData) {
      setArticleFilterData(articleFilterData);
    }
  }, []);

  // Apply Filter Function
  const applyFilter = (
    articleCategory,
    articleDate,
    articleAuthor,
    articleDeliveredAt
  ) => {
    const articleData = {
      articleCategory,
      articleDate,
      articleAuthor,
      articleDeliveredAt,
    };
    setCookie("articleFilter", encrypt(JSON.stringify(articleData)));

    // Get Data For Title Name
    const savedArticleFilterData = JSON.parse(
      decrypt(getCookie("articleFilter")) || "{}"
    );
    setArticleFilterData(savedArticleFilterData);
    // Set Title Name as Category
    setArticleCategoryName(
      categoryList.find(
        (data) => data.value == savedArticleFilterData.articleCategory
      )
    );
  };

  // Clear Filter Function
  const clearFilter = () => {
    setArticleCategory("");
    setArticleDate("");
    setArticleAuthor("");
    setArticleDeliveredAt("");
    setArticleCategoryName("");
    deleteCookie("articleFilter");
    setArticleFilterData({});
  };

  useEffect(() => {
    if (menu) {
      setMainMenu(menu);
    }
  }, [menu]);

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[3%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              {mainMenu === "Article"
                ? (articleCategoryName && articleCategoryName.label) ||
                  "Article"
                : mainMenu === "Presentation"
                ? "Presentations"
                : mainMenu === "Videos"
                ? "Videos"
                : mainMenu === "Recent Question"
                ? "Queries"
                : ""}
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="relative w-full md:w-[80%] lg:w-[60%] xl:w-[50%] mb-[5%] md:mb-[3%] flex justify-evenly py-[2%] md:py-[1%] mx-auto rr-main-menu">
            <Link
              className={
                mainMenu === "Article" ? "rrmm-box-active rrmm-box" : "rrmm-box"
              }
              onClick={() => {
                setMainMenu("Article");
                setArticleType("text");
              }}
            >
              Article
            </Link>
            <Link
              className={
                mainMenu === "Presentation"
                  ? "rrmm-box-active rrmm-box"
                  : "rrmm-box"
              }
              onClick={() => {
                setMainMenu("Presentation");
                setArticleType("presentation");
              }}
            >
              Presentation
            </Link>
            <Link
              className={
                mainMenu === "Videos" ? "rrmm-box-active rrmm-box" : "rrmm-box"
              }
              onClick={() => {
                setMainMenu("Videos");
                setArticleType("video");
              }}
            >
              Videos
            </Link>
            <Link
              className={
                mainMenu === "Recent Question"
                  ? "rrmm-box-active rrmm-box"
                  : "rrmm-box"
              }
              onClick={() => {
                setMainMenu("Recent Question");
                setArticleType("");
              }}
            >
              Recent question
            </Link>
          </div>
          {/* Filter */}
          <div className="w-full mb-[5%] md:mb-[3%]">
            {mainMenu != "Recent Question" && (
              <div className="w-full grid grid-cols-2 lg:grid-cols-5 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                <div className="w-full">
                  <Select
                    name="category"
                    id="category"
                    placeholder="Category"
                    className="w-full form-select form-input form-input2"
                    isSearchable={true}
                    options={categoryList}
                    value={
                      categoryList.find(
                        (item) => item.value == articleCategory
                      ) || ""
                    }
                    onChange={(e) => setArticleCategory(e.value)}
                    styles={selectFormStyle2}
                  />
                </div>
                <div className="w-full">
                  <input
                    className="w-full form-input form-input2"
                    type="date"
                    placeholder=""
                    id="date"
                    value={articleDate}
                    onChange={(e) => setArticleDate(e.target.value)}
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                  />
                </div>
                <div className="w-full">
                  <Select
                    name="author"
                    id="author"
                    placeholder="Author"
                    className="w-full form-select form-input form-input2"
                    isSearchable={true}
                    options={authorList}
                    value={
                      authorList.find((item) => item.value == articleAuthor) ||
                      ""
                    }
                    onChange={(e) => setArticleAuthor(e.value)}
                    styles={selectFormStyle2}
                  />
                </div>
                <div className="w-full">
                  <Select
                    name="deliveredAt"
                    id="deliveredAt"
                    placeholder="Delivered at"
                    className="w-full form-select form-input form-input2"
                    isSearchable={true}
                    options={deliveredAtList}
                    value={
                      deliveredAtList.find(
                        (item) => item.value == articleDeliveredAt
                      ) || ""
                    }
                    onChange={(e) => setArticleDeliveredAt(e.value)}
                    styles={selectFormStyle2}
                  />
                </div>
                <div className="w-full">
                  <button
                    onClick={() =>
                      applyFilter(
                        articleCategory,
                        articleDate,
                        articleAuthor,
                        articleDeliveredAt
                      )
                    }
                    type="button"
                    className="w-full btn-filter"
                  >
                    Apply filter
                  </button>
                </div>
                <div className="w-full lg:col-start-5 lg:col-end-6 h-auto">
                  <div
                    type="button"
                    onClick={() => clearFilter()}
                    className="w-full h-full flex items-center justify-center lg:justify-end"
                  >
                    <button className="btn-filter-clear">Clear filter</button>
                  </div>
                </div>
              </div>
            )}
            {mainMenu == "Recent Question" && (
              <div className="w-full grid grid-cols-2 lg:grid-cols-5 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                <div className="w-full lg:col-start-2 lg:col-end-3">
                  <Select
                    name="category"
                    id="category"
                    placeholder="Category"
                    className="w-full form-select form-input form-input2"
                    isSearchable={true}
                    options={categoryList}
                    value={
                      categoryList.find(
                        (item) => item.value == articleCategory
                      ) || ""
                    }
                    onChange={(e) => setArticleCategory(e.value)}
                    styles={selectFormStyle2}
                  />
                </div>
                <div className="w-full lg:col-start-3 lg:col-end-4">
                  <input
                    className="w-full form-input form-input2"
                    type="date"
                    placeholder=""
                    id="date"
                    value={articleDate}
                    onChange={(e) => setArticleDate(e.target.value)}
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                  />
                </div>
                <div className="w-full lg:col-start-4 lg:col-end-5">
                  <button
                    onClick={() =>
                      applyFilter(
                        articleCategory,
                        articleDate,
                        articleAuthor,
                        articleDeliveredAt
                      )
                    }
                    type="button"
                    className="w-full btn-filter"
                  >
                    Apply filter
                  </button>
                </div>
                <div className="w-full lg:col-start-4 lg:col-end-5 h-auto">
                  <div
                    type="button"
                    onClick={() => clearFilter()}
                    className="w-full h-full flex items-center justify-center lg:justify-end"
                  >
                    <button className="btn-filter-clear">Clear filter</button>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Article */}
          {mainMenu === "Article" ? (
            <ArticleList
              id={articleFilterData && articleFilterData.articleCategory}
              type={"text"}
              date={articleFilterData && articleFilterData.articleDate}
              authorId={articleFilterData && articleFilterData.articleAuthor}
              deliveredAt={
                articleFilterData && articleFilterData.articleDeliveredAt
              }
            />
          ) : (
            ""
          )}
          {/* Presentation */}
          {mainMenu === "Presentation" ? (
            <PresentationList
              id={articleFilterData && articleFilterData.articleCategory}
              type={"presentation"}
              date={articleFilterData && articleFilterData.articleDate}
              authorId={articleFilterData && articleFilterData.articleAuthor}
              deliveredAt={
                articleFilterData && articleFilterData.articleDeliveredAt
              }
            />
          ) : (
            ""
          )}
          {/* Videos */}
          {mainMenu === "Videos" ? (
            <VideoList
              id={articleFilterData && articleFilterData.articleCategory}
              type={"video"}
              date={articleFilterData && articleFilterData.articleDate}
              authorId={articleFilterData && articleFilterData.articleAuthor}
              deliveredAt={
                articleFilterData && articleFilterData.articleDeliveredAt
              }
            />
          ) : (
            ""
          )}
          {/* Recent Question */}
          {mainMenu === "Recent Question" ? (
            <QueriesList
              id={articleFilterData && articleFilterData.articleCategory}
              type={"queries"}
              date={articleFilterData && articleFilterData.articleDate}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default ArticleFormat;
